/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState, useRef } from 'react'
import { Form, Field } from 'formik'
import {
    Row,
    Col,
    Tooltip,
    Menu,
    Dropdown,
    Icon,
    Tag,
    Input,
    Button,
    Progress,
    Popover,
    Avatar,
} from 'antd'
import { connect } from 'react-redux'

import {
    AntDatePicker,
    AntSelect,
    AntTextArea,
    AntProgress,
    AntEditor,
} from '../../../../../componentIsoMophic/ScrumBoard/AntFields'
import { dateFormat } from '../../../../../componentIsoMophic/ScrumBoard/FieldFormats'
import CreateReportHeader from '../CreateReportHeader/CreateReportHeader'
import HeadingWithIcon from '../../../../../componentIsoMophic/ScrumBoard/HeadingWithIcon/HeadingWithIcon'
import TitleIcon from '../../../../assets/images/icon/05-icon.svg'
import DescriptionIcon from '../../../../assets/images/icon/06-icon.svg'
import AttachmentIcon from '../../../../assets/images/icon/01-icon.svg'
import { IconSvg } from '../../../../../componentIsoMophic/ScrumBoard/IconSvg/IconSvg'
import OrgAction from '../../../../../redux/organization/actions'
import scrumBoardActions from '../../../../../redux/scrumBoard/actions'
import mediaAction from '../../../../../redux/qbmedia/actions'
import objectAction from '../../../../../redux/object/actions'
import EventAction from '../../../../../redux/event/actions'
import SelectObjectComponent from '../../../../../components/select_objects'

import Modal from '../../../../..//components/feedback/modal'
import MediaManagementScreen from '../../../../MediaManagement/index'
import ObjectsScreen from '../../../../ObjectsManagement/index'
import { FaPlusCircle } from 'react-icons/fa'
import SelectMediaComponent from '../../../../../components/select_medias'
import { MdAssignment, MdViewModule } from 'react-icons/md'
import { IoIosPaperPlane } from 'react-icons/io'
import { FaCalendarCheck } from 'react-icons/fa'
import SelectEventComponent from '../../../../../components/select_events'
import defaultImgEvent from '../../../../../resource/image/imgEventDefaul.jpg'
import objectDefault from '../../../../../resource/image/objectDefault.png'

const ButtonGroup = Button.Group
let temp = 1

const RenderReportForm = ({
    handleSubmit,
    values,
    submitCount,
    onCancel,
    onDelete,
    onEditCancel,
    updateListOrgQuery,
    listOrgUpdate,
    updateHashTag,
    listUpdateHashTag,
    ListCurrentMedia,
    getListMediaQueryById,
    getListMediaQueryByIdDone,
    showModalMedia,
    VisibleModalMedia,
    VisibleModalObject,
    showModalObject,
    ListCurrentObject,
    ListCurrentEvent,
    events,
    updateListCurrentEvent,
    getListEvent,
    getListCurrentEvent,
    getListObjectQueryById,
    totalEvent,
    applyToMedia,
    applyToCurrentObject,
    getListObjectQueryById_done,
    getListCurrentEventDone,
    VisibleModalEvent,
    visibleModalEvent,
}) => {
    useEffect(() => {
        getListEvent(1, 10, 0)
        if (values.event) {
            getListCurrentEvent(values.event.toString())
        }
        if (values.media) {
            getListMediaQueryById(values.media.toString())
        }
        if (values.object) {
            getListObjectQueryById(values.object.toString())
        }
        return () => {
            getListMediaQueryByIdDone([])
            getListObjectQueryById_done([])
            getListCurrentEventDone([])
            console.log('reset data update task')
        }
    }, [getListMediaQueryById, getListMediaQueryByIdDone])
    const [update, setupdate] = useState()
    const [visible, setvisible] = useState(false)
    const [hashtag, sethashtag] = useState('')
    const form = useRef(null)
    console.log('values report ', values)
    console.log('list hash tag create report ', listUpdateHashTag)
    const clickLoadMoreEvent = () => {
        getListEvent(temp + 1, 10, 0)
        temp = temp + 1
    }
    const _userSelectMedia = medias => {
        console.log('medias : ', medias)
        showModalMedia(false)
        applyToMedia([])
        applyToMedia(medias)
    }
    const _userSelectObject = objects => {
        showModalObject(false)
        applyToCurrentObject([])
        applyToCurrentObject(objects)
    }
    const _userSelectEvent = events => {
        visibleModalEvent(false)
        updateListCurrentEvent([])
        updateListCurrentEvent(events)
    }

    const handleAddTag = () => {
        setvisible(false)
        if (hashtag.trim() !== '') {
            updateHashTag(hashtag)
        }
        sethashtag('')
    }
    const menuHashtag = (
        <Menu>
            <Menu.Item>
                <Input
                    placeholder="Nhập hashtag"
                    maxLength={25}
                    value={hashtag}
                    style={{ width: 200 }}
                    onChange={e => sethashtag(e.target.value)}
                />
                <Button
                    type="primary"
                    onClick={handleAddTag}
                    style={{ marginLeft: 10 }}
                >
                    Thêm
                </Button>
                <Button
                    type="primary"
                    onClick={() => {
                        setvisible(false)
                        sethashtag('')
                    }}
                    style={{ marginLeft: 10 }}
                >
                    Huỷ
                </Button>
            </Menu.Item>
        </Menu>
    )
    const getRandomInt = max => {
        return Math.floor(Math.random() * Math.floor(max))
    }
    const getColorTag = () => {
        const color = [
            'magenta',
            'red',
            'volcano',
            'orange',
            'gold',
            'lime',
            'green',
            'cyan',
            'blue',
            'geekblue',
            'purple',
        ]
        const index = getRandomInt(color.length)

        return color[index]
    }

    const handleVisibleChange = visible => {
        setvisible(visible)
        sethashtag('')
    }

    return (
        <Form ref={form} onSubmit={handleSubmit}>
            <CreateReportHeader
                values={values}
                onCancel={onCancel}
                onDelete={onDelete}
                onEditCancel={onEditCancel}
            />
            <Field
                component={AntTextArea}
                name="title"
                type="text"
                tasklabel={
                    <HeadingWithIcon
                        heading="Tên báo cáo*"
                        iconSrc={TitleIcon}
                    />
                }
                placeholder="Thêm tên báo cáo "
                submitCount={submitCount}
                hasFeedback
                rows={2}
                formitem={{
                    colon: false,
                }}
            />
            <Row gutter={16}>
                <Col md={12}>
                    <HeadingWithIcon
                        icon={
                            <MdAssignment
                                style={{
                                    paddingRight: 7,
                                    height: 20,
                                    width: 20,
                                }}
                            />
                        }
                        heading={`Tài liệu liên quan `}
                    />
                    {ListCurrentMedia.map(media => (
                        <div
                            style={{
                                display: 'flex',
                                flexDirection: 'row',
                                alignItems: 'center',
                            }}
                        >
                            <Button
                                type="link"
                                // href={media.url}
                                target="_blank"
                                onClick={() => {
                                    window.open(media.url, '_blank')
                                }}
                                block={false}
                                style={{ paddingLeft: 5 }}
                            >
                                {media.name}
                            </Button>
                            <Icon
                                style={{ cursor: 'pointer' }}
                                type="close"
                                onClick={() => {
                                    for (
                                        let i = 0;
                                        i < ListCurrentMedia.length;
                                        i++
                                    ) {
                                        if (
                                            ListCurrentMedia[i].media_id ===
                                            media.media_id
                                        ) {
                                            ListCurrentMedia.splice(i, 1)
                                            setupdate({})
                                        }
                                    }
                                }}
                            />
                        </div>
                    ))}
                    <Button
                        type="primary"
                        icon="upload"
                        onClick={() => showModalMedia(true)}
                        style={{ width: 150 }}
                    >
                        Chọn tài liệu
                    </Button>
                </Col>

                <Col md={12}>
                    <HeadingWithIcon heading="# HashTag" />
                    <p>
                        {values.labels.map(label => (
                            <Tooltip
                                title={label}
                                placement="bottom"
                                key={label}
                            >
                                <Tag color={getColorTag()}>{label}</Tag>
                            </Tooltip>
                        ))}
                        {listUpdateHashTag.map(label => (
                            <Tooltip
                                title={label}
                                placement="bottom"
                                key={label}
                            >
                                <Popover
                                    content={
                                        <a
                                            onClick={() => {
                                                for (
                                                    let i = 0;
                                                    i <
                                                    listUpdateHashTag.length;
                                                    i++
                                                ) {
                                                    if (
                                                        listUpdateHashTag[i] ===
                                                        label
                                                    ) {
                                                        listUpdateHashTag.splice(
                                                            i,
                                                            1
                                                        )
                                                        setupdate({})
                                                    }
                                                }
                                                // this.setState(
                                                //     {
                                                //         visibleDelete: false,
                                                //     }
                                                // )
                                            }}
                                        >
                                            Xoá hashtag này
                                        </a>
                                    }
                                    trigger="click"
                                >
                                    <Tag color={getColorTag()}>{label}</Tag>
                                </Popover>
                            </Tooltip>
                        ))}

                        <Tooltip title="Thêm Hashtag" placement="bottom">
                            <Dropdown
                                overlay={menuHashtag}
                                trigger={['click']}
                                visible={visible}
                                onVisibleChange={handleVisibleChange}
                            >
                                <FaPlusCircle
                                    style={{
                                        width: 30,
                                        height: 30,
                                        marginLeft: 10,
                                        marginTop: 5,
                                    }}
                                    color="#4d95be"
                                    onClick={() => setvisible(true)}
                                />
                            </Dropdown>
                        </Tooltip>
                    </p>
                </Col>
            </Row>
            <Row gutter={16}>
                <Col md={12}>
                    <HeadingWithIcon
                        icon={
                            <IoIosPaperPlane
                                style={{
                                    paddingRight: 7,
                                    height: 20,
                                    width: 20,
                                }}
                            />
                        }
                        heading={`Đối tượng liên quan `}
                    />
                    <div>
                        {ListCurrentObject.map(object => (
                            <Tooltip
                                title={object.name}
                                placement="bottom"
                                key={object}
                            >
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href={`/app/qbobjects/${object.object_id}`}
                                >
                                    <Avatar
                                        shape="square"
                                        size={64}
                                        src={object.avatar === '' ? objectDefault : object.avatar}
                                        style={{ margin: 10 }}
                                    />
                                </a>
                            </Tooltip>
                        ))}
                    </div>
                    <Button
                        type="primary"
                        icon="upload"
                        onClick={() => showModalObject(true)}
                        style={{ marginTop: 10, width: 150 }}
                    >
                        Chọn đối tượng
                    </Button>
                </Col>
                <Col md={12}>
                    <HeadingWithIcon
                        icon={
                            <FaCalendarCheck
                                style={{
                                    paddingRight: 7,
                                    height: 20,
                                    width: 20,
                                }}
                            />
                        }
                        heading={`Sự kiện liên quan `}
                    />
                    <div>
                        {ListCurrentEvent.map(event => (
                            <Tooltip
                                title={event.name}
                                placement="bottom"
                                key={event}
                            >
                                <a
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    href={`/app/qbevents/${event.event_id}`}
                                >
                                    <Avatar
                                        shape="square"
                                        size={64}
                                        src={
                                            event.avatar === ''
                                                ? defaultImgEvent
                                                : event.avatar
                                        }
                                        style={{ margin: 10 }}
                                    />
                                </a>
                            </Tooltip>
                        ))}
                    </div>
                    <Button
                        type="primary"
                        icon="upload"
                        onClick={() => visibleModalEvent(true)}
                        style={{ marginTop: 10, width: 150 }}
                    >
                        Chọn sự kiện
                    </Button>
                </Col>
            </Row>
            <Row gutter={16}></Row>

            <Row gutter={16}>
                {/* <Col span={8}>
                    <Field
                        component={AntSelect}
                        mode="multiple"
                        name="assignees"
                        tasklabel={<HeadingWithIcon heading="Assign Members" />}
                        defaultValue={values.assignees}
                        selectOptions={values.selectAssignees}
                        submitCount={submitCount}
                        tokenSeparators={[',']}
                        hasFeedback
                        size="large"
                    />
                </Col> */}
                {/* <Col span={8}>
                    <Field
                        component={AntSelect}
                        mode="multiple"
                        name="labels"
                        tasklabel={<HeadingWithIcon heading="Labels" />}
                        defaultValue={values.labels}
                        selectOptions={values.selectOptions}
                        submitCount={submitCount}
                        tokenSeparators={[',']}
                        hasFeedback
                        size="large"
                    />
                </Col> */}
            </Row>
            <HeadingWithIcon
                heading="Nội dung báo cáo"
                iconSrc={DescriptionIcon}
            />
            <Field
                component={AntEditor}
                name="description"
                type="text"
                placeholder="Nhập nội dung báo cáo"
                submitCount={submitCount}
                rows={10}
                hasFeedback
                formitem={{
                    colon: false,
                }}
            />
            {VisibleModalEvent && (
                <Modal
                    visible={true}
                    title="Sự kiện liên quan"
                    onOk={() => visibleModalEvent(false)}
                    onCancel={() => visibleModalEvent(false)}
                    width={900}
                    centered
                    footer={[]}
                >
                    <SelectEventComponent
                        onSuccess={events => _userSelectEvent(events)}
                        onCancel={() => visibleModalEvent(false)}
                        initEvent={ListCurrentEvent}
                    />
                </Modal>
            )}
            {VisibleModalMedia && (
                <Modal
                    visible={true}
                    title="Lựa chọn tài liệu"
                    onOk={() => showModalMedia(false)}
                    onCancel={() => showModalMedia(false)}
                    centered
                    width={900}
                    footer={null}
                >
                    <SelectMediaComponent
                        onSuccess={medias => _userSelectMedia(medias)}
                        onCancel={() => showModalMedia(false)}
                        initMedia={ListCurrentMedia}
                    />
                </Modal>
            )}
            {VisibleModalObject && (
                <Modal
                    visible={true}
                    title="Lựa chọn đối tượng"
                    onOk={() => showModalObject(false)}
                    onCancel={() => showModalObject(false)}
                    width={900}
                    centered
                    footer={[]}
                >
                    <SelectObjectComponent
                        onSuccess={objects => _userSelectObject(objects)}
                        onCancel={() => showModalObject(false)}
                        initObject={ListCurrentObject}
                    />
                </Modal>
            )}
        </Form>
    )
}
export default connect(
    (state, ownProps) => {
        return {
            listOrgUpdate: state.organization.listOrgUpdate,
            listUpdateHashTag: state.scrumBoard.listUpdateHashTag,
            ListCurrentMedia: state.scrumBoard.ListCurrentMedia,
            ListCurrentObject: state.scrumBoard.ListCurrentObject,
            VisibleModalMedia: state.scrumBoard.VisibleModalMedia,
            VisibleModalObject: state.scrumBoard.VisibleModalObject,
            ListCurrentEvent: state.scrumBoard.ListCurrentEvent,
            events: state.eventReducer.events,
            totalEvent: state.eventReducer.totalEvent,
            VisibleModalEvent: state.scrumBoard.VisibleModalEvent,
        }
    },
    {
        ...OrgAction.action,
        ...scrumBoardActions,
        ...mediaAction.action,
        ...objectAction.action,
        ...EventAction.action,
    }
)(RenderReportForm)
